import { useRef } from "react";
import { useAppState } from "../../../context/app/context";
import { useCartService } from "../../../hooks/use-cart-service";
import useScript from "../../../hooks/use-script";
import { handleCookieConsent, setCookie } from "../../cookies/cookie-service";
import { getQueryStringParam } from "../../query-string";

export const useAwin = () => {
	const { store } = useAppState();
	const { cart, setCartCustomField, cartLoading } = useCartService();

	const awinMerchantId = store.awinMerchantID || undefined;
	const awinParameter = getQueryStringParam("awc");
	const awinDataSet = useRef(false);

	handleCookieConsent(`_awc_${awinMerchantId}`, "targeting");

	if (!awinDataSet.current && !cartLoading && awinMerchantId && awinParameter) {
		if (cart?.custom.fields.awinId !== awinParameter)
			void setCartCustomField("awinId", awinParameter);

		const expiryDate = new Date();
		// 30 days
		expiryDate.setDate(expiryDate.getDate() + 30);
		console.log("Setting awin cookie");
		setCookie({
			name: `_awc_${awinMerchantId}`,
			value: awinParameter,
			attributes: {
				expires: expiryDate,
				path: "/",
				secure: true,
				sameSite: "none",
			},
			requireConsent: "targeting",
		});
		awinDataSet.current = true;
	}

	// Load the Awin script
	useScript({
		script: {
			id: "awin_script",
			type: "text/javascript",
			src: `https://www.dwin1.com/${awinMerchantId}.js`,
			defer: true,
		},
		removeOnUnmount: false,
		shouldRender: !!awinMerchantId,
	});
};
